import React from 'react';
import { createRoot } from 'react-dom/client';
import Root from './Root';
import { getFirebaseAuth } from './config/firebase';
import { i18nReady } from '../../web-x9/src/i18n';
import './index.css';
import '../../web-x9/src/index.css';

getFirebaseAuth();

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root not found');

// Mount only once `t` returns phrases. The creation wizards paint on the first
// frame, with no account to wait for, so anything earlier shows raw keys.
// index.html's own loader covers this tick.
void i18nReady.then(() => {
  rootEl.innerHTML = '';
  createRoot(rootEl).render(
    <React.StrictMode>
      <Root />
    </React.StrictMode>,
  );
});
